<nz-tree-select style="width: 100%" 
[nzNodes]="options" 
    [nzShowSearch]="showSearch"
    [nzCheckable]="checkable"
    [id]="selectElementId"
    [formControl]="itemsFormControl"
    [nzPlaceHolder]="placeHolder"
    [nzDropdownStyle]="dropdownStyle"
    [nzMaxTagCount]="maxTagCount">
</nz-tree-select>